import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import SEO from "../components/SEO";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { FiCalendar, FiArrowLeft, FiShare2 } from "react-icons/fi";

export default function BlogPost() {
    const { id } = useParams();
    const [post, setPost] = useState(null);
    const [suggestedProduct, setSuggestedProduct] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isLightboxOpen, setIsLightboxOpen] = useState(false);

    useEffect(() => {
        async function load() {
            try {
                const snap = await getDoc(doc(db, "blog", id));
                if (snap.exists()) {
                    const data = snap.data();
                    setPost(data);

                    if (data.suggestedProductId) {
                        const pSnap = await getDoc(doc(db, "products", data.suggestedProductId));
                        if (pSnap.exists()) setSuggestedProduct({ id: pSnap.id, ...pSnap.data() });
                    }
                }
            } catch (e) {
                console.error("Error loading post:", e);
            }
            setLoading(false);
        }
        load();
    }, [id]);

    if (loading) return <div className="container" style={{ padding: 100, textAlign: "center", color: "#888" }}>Loading story...</div>;
    if (!post) return <div className="container" style={{ padding: 100, textAlign: "center" }}>Post not found. <br/><Link to="/news">Back to News</Link></div>;

    const plainExcerpt = post.content ? post.content.replace(/<[^>]*>/g, '').substring(0, 160) : "";

    return (
        <div className="blog-post-page">
            <SEO 
                pageId="blog" 
                manualData={{
                    title: post.title,
                    description: plainExcerpt,
                    image: post.imageUrl
                }} 
            />
            {/* Clean Header */}
            <div style={{ background: "#fdf8e6", padding: "80px 0", textAlign: "center", borderBottom: "1px solid #eee" }}>
                <div className="container">
                    <div style={{ display: "inline-flex", alignItems: "center", gap: 8, color: "var(--accent)", fontSize: 14, fontWeight: 700, marginBottom: 16, textTransform: "uppercase" }}>
                        <FiCalendar size={16} />
                        {post.date ? new Date(post.date + "T00:00:00").toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : (post.createdAt?.toDate ? post.createdAt.toDate().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : "Recent Update")}
                    </div>
                    <h1 style={{ fontSize: "3.5rem", fontFamily: "'Playfair Display', serif", marginBottom: 0, lineHeight: 1.2, color: "#0d4a35" }}>{post.title}</h1>
                </div>
            </div>

            <div className="container" style={{ padding: "80px 20px" }}>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 60 }}>
                    
                    {/* Sidebar / Actions */}
                    <div style={{ flex: "0 0 200px" }}>
                        <Link to="/news" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none", color: "#666", fontWeight: 700, fontSize: 14, marginBottom: 40 }}>
                            <FiArrowLeft size={18} /> Back to News
                        </Link>
                        <div style={{ padding: 24, background: "#fdf8e6", borderRadius: 16 }}>
                            <p style={{ fontSize: 12, fontWeight: 700, textTransform: "uppercase", color: "#888", marginBottom: 12 }}>Share Story</p>
                            <button 
                                onClick={() => {
                                    navigator.clipboard.writeText(window.location.href);
                                    alert("Link copied to clipboard!");
                                }}
                                style={{ background: "white", border: "1px solid #eee", width: "100%", padding: "10px", borderRadius: 8, cursor: "pointer", display: "flex", alignItems: "center", gap: 8, fontWeight: 600, fontSize: 13 }}
                            >
                                <FiShare2 size={14} /> Copy Link
                            </button>
                        </div>
                    </div>

                    {/* Content */}
                    <div style={{ flex: "1 1 600px", maxWidth: 800 }}>
                        <div 
                            className="blog-rich-content"
                            dangerouslySetInnerHTML={{ __html: post.content }}
                        />

                        {/* Uploaded Image at the end */}
                        {post.imageUrl && (
                            <div style={{ marginTop: 40, textAlign: "center" }}>
                                <img 
                                    src={post.imageUrl} 
                                    alt={post.title} 
                                    onClick={() => setIsLightboxOpen(true)}
                                    style={{ width: "25%", minWidth: "200px", borderRadius: 8, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", cursor: "zoom-in" }} 
                                />
                            </div>
                        )}

                        {suggestedProduct && (
                            <div style={{ marginTop: 80, borderTop: "1px solid #eee", paddingTop: 60 }}>
                                <h4 style={{ fontSize: "1.1rem", textTransform: "uppercase", letterSpacing: 2, color: "#888", marginBottom: 30, textAlign: "center" }}>Featured in this story</h4>
                                <Link to={`/book/${suggestedProduct.id}`} className="suggested-product-card" style={{ display: "flex", gap: 30, background: "#fdf8e6", padding: 30, borderRadius: 20, textDecoration: "none", color: "inherit", alignItems: "center", transition: "transform 0.3s" }}>
                                    <div style={{ width: 120, height: 180, flexShrink: 0, boxShadow: "0 10px 20px rgba(0,0,0,0.15)", borderRadius: 8, overflow: "hidden" }}>
                                        <img src={suggestedProduct.imageUrl} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <h3 style={{ margin: "0 0 10px", fontSize: "1.5rem", fontFamily: "'Playfair Display', serif", color: "var(--green-primary)" }}>{suggestedProduct.title}</h3>
                                        <p style={{ margin: "0 0 20px", color: "#666", fontSize: 14 }}>{suggestedProduct.excerpt || "Check out this featured release from LB Books."}</p>
                                        <div style={{ display: "inline-block", background: "var(--accent)", color: "white", padding: "10px 24px", borderRadius: 30, fontWeight: 700, fontSize: 13 }}>View Product Details</div>
                                    </div>
                                </Link>
                            </div>
                        )}
                    </div>

                </div>
            </div>

            <style>{`
                .blog-rich-content {
                    font-size: 1.2rem;
                    line-height: 1.8;
                    color: #333;
                }
                .blog-rich-content p { margin-bottom: 24px; }
                .blog-rich-content h2, .blog-rich-content h3 { 
                    font-family: 'Playfair Display', serif; 
                    margin: 48px 0 20px;
                    color: var(--green-primary);
                }
                .suggested-product-card:hover {
                    transform: translateY(-5px);
                }
                @media (max-width: 900px) {
                    .blog-post-page h1 { font-size: 2.5rem !important; }
                    .suggested-product-card { flex-direction: column; text-align: center; }
                }
            `}</style>

            {/* Lightbox Overlay */}
            {isLightboxOpen && post.imageUrl && (
                <div 
                    style={{ position: "fixed", inset: 0, backgroundColor: "rgba(0,0,0,0.85)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: 40, cursor: "zoom-out" }}
                    onClick={() => setIsLightboxOpen(false)}
                >
                    <img 
                        src={post.imageUrl} 
                        alt={post.title} 
                        style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: 8, boxShadow: "0 10px 40px rgba(0,0,0,0.3)" }} 
                    />
                </div>
            )}
        </div>
    );
}
